<template>
<router-view />
</template>

<script>
export default {
  name: 'StatisticalAnalysis',
  routeInfo: {
    label: '数据分析'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/index.vue